import { GridRow } from '@shared';
import { Category } from './category.model';

export class GridRowCategory extends GridRow(Category) {}
